import { render, staticRenderFns } from "./CompareCombo.vue?vue&type=template&id=c4049382&scoped=true"
import script from "./CompareCombo.vue?vue&type=script&lang=js"
export * from "./CompareCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4049382",
  null
  
)

export default component.exports